import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { cilMenu } from '@coreui/icons'
import routes from '../routes'
import { CBreadcrumb, CBreadcrumbItem, CHeaderToggler } from '@coreui/react'
import { decryptString } from '../services/crypto'
import CIcon from '@coreui/icons-react'

const AppBreadcrumb = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const currentLocation = useLocation().pathname
  const [isMobile, setIsMobile] = useState(decryptString('isMobile'))

  const getRouteName = (pathname, routes) => {
    const currentRoute = routes.find((route) => route.path === pathname)
    return currentRoute ? currentRoute.name : false
  }

  const getBreadcrumbs = (location) => {
    const breadcrumbs = []
    location.split('/').reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`
      const routeName = getRouteName(currentPathname, routes)
      routeName &&
        breadcrumbs.push({
          pathname: `#${currentPathname}`,
          name: routeName,
          active: index + 1 === array.length ? true : false,
        })
      return currentPathname
    })
    return breadcrumbs
  }

  const breadcrumbs = getBreadcrumbs(currentLocation)

  return (
    <CBreadcrumb className="m-0 ms-2 breadcrumb-header align-breadcrumb">
      <CHeaderToggler
        className="ps-1 show-hamburguer-menu"
        onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
      >
        <CIcon icon={cilMenu} size="lg" />
      </CHeaderToggler>
      <>
        {!isMobile && <CBreadcrumbItem href="#/dashboard">Dashboard</CBreadcrumbItem>}
        {breadcrumbs.map((breadcrumb, index) => {
          if (breadcrumb.name !== 'Dashboard' && !isMobile) {
            return (
              <CBreadcrumbItem
                {...(breadcrumb.active ? { active: true } : { href: breadcrumb.pathname })}
                key={index}
              >
                {breadcrumb.name}
              </CBreadcrumbItem>
            )
          }

          return null
        })}
      </>
    </CBreadcrumb>
  )
}

export default React.memo(AppBreadcrumb)
